import { render, staticRenderFns } from "./SPIFIndustrySummary.vue?vue&type=template&id=a258dfac"
import script from "./SPIFIndustrySummary.vue?vue&type=script&lang=js"
export * from "./SPIFIndustrySummary.vue?vue&type=script&lang=js"
import style0 from "./SPIFIndustrySummary.vue?vue&type=style&index=0&id=a258dfac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports